import { render } from "./HistoryMoblie.vue?vue&type=template&id=4a2dc4f5&scoped=true"
import script from "./HistoryMoblie.vue?vue&type=script&lang=js"
export * from "./HistoryMoblie.vue?vue&type=script&lang=js"

import "./HistoryMoblie.vue?vue&type=style&index=0&id=4a2dc4f5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2dc4f5"]])

export default __exports__